export default "ui-chart-stock{display:block}\n";